<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 5H4C2.89543 5 2 5.89543 2 7V18.835C2 19.9396 2.89543 20.835 4 20.835H20C21.1046 20.835 22 19.9396 22 18.835V7C22 5.89543 21.1046 5 20 5Z"
      fill="#FFC304"
    />
    <path
      d="M10 3H4C2.89543 3 2 3.89543 2 5V7C2 8.10457 2.89543 9 4 9H10C11.1046 9 12 8.10457 12 7V5C12 3.89543 11.1046 3 10 3Z"
      fill="#FFC304"
    />
    <path
      d="M7.41421 12.3436L6 13.7578L10.2426 18.0005L11.6569 16.5862L7.41421 12.3436Z"
      fill="#3CB149"
    />
    <path
      d="M16.4706 9.00087L17.9994 10.5013L10.357 18.0023L8.82822 16.5019L16.4706 9.00087Z"
      fill="#3CB149"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
